import {ButtonProps} from '@logistics-frontend/blocks'

import {
  ActionCancelV2,
  CancelMessageActionContinueOrderCancellation,
  CancelMessageActionDismiss,
  CancelMessageButtonAction,
} from 'src/api/cargo-c2c/types'

type AllowedCancelButton = CancelMessageActionDismiss | CancelMessageActionContinueOrderCancellation
type AllowedCancelButtonType = AllowedCancelButton['type']
type MessageButtonType = 'free_cancel' | 'paid_cancel' | 'do_not_cancel'
export type MessageButton = {
  type: MessageButtonType
  variant: ButtonProps['variant']
  title: string
  onClick?(): void
}
export type Message = {
  revision: number
  title: string
  body?: string
  buttons: MessageButton[]
  opened: boolean
}

const allowedType: Record<AllowedCancelButtonType, MessageButtonType> = {
  continue_order_cancellation: 'free_cancel',
  dismiss_cancel_message: 'do_not_cancel',
}

export function toCancelMessage({message}: ActionCancelV2, revision: number): Message {
  return {
    revision,
    opened: false,
    title: message.title,
    body: message.body,
    buttons: message.buttons.reduce<MessageButton[]>((acc, button) => {
      if (isAllowedButton(button.action)) {
        acc.push({
          type: allowedType[button.action.type],
          variant: button.highlighted ? 'action' : 'default',
          title: button.title,
        })
      }

      return acc
    }, []),
  }
}

function isAllowedButton(buttonAction: CancelMessageButtonAction): buttonAction is AllowedCancelButton {
  return ['dismiss_cancel_message', 'continue_order_cancellation'].includes(buttonAction.type)
}
